//CheckboxSale.tsx =================================================
import "../Util/Prototypes";

import * as GetSales from "./GetSales";
import * as SalesAverages from "./SalesAverages";

import { Checkbox, FormControlLabel } from "@mui/material";

import React from "react";

interface iProps {
   feature?: any; // __esri.Graphic;
   ii?: number;
}

export function Render(props: iProps) {
   //Set refresh method.
   const [rowSelected, setValue] = React.useState(props.feature.rowSelected || false);

   //Value changed.

   function handleClick(feature: any, event: any) { // React.MouseEvent<HTMLLabelElement, MouseEvent>) {
      feature.rowSelected = event.target.checked;
      SalesAverages.computeSalesAves();
      SalesAverages.refreshExternal();
      GetSales.addHighlightGraphics(); //Add yellow background highlight graphics.
      setValue(feature.rowSelected);
      event.stopPropagation();
   }

   return (
      <FormControlLabel style={{ marginRight: 7 }}
         control={<Checkbox inputProps={{ id: "checkbox-sale-" + props.ii }} color="primary" checked={rowSelected} />}
         onClick={(event) => handleClick(props.feature, event)}
         label=""
         aria-label="Select row"
      />
   ); //end return.

} //end function.
